import React, { Fragment, useState } from "react";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { FAQs } from "../FAQs";

const Tabs = ({ data }) => {
  const { tabContent } = data;
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="flex flex-wrap items-center justify-center">
      <div className="flex w-full basis-full flex-wrap items-center justify-center">
        {tabContent?.map((tab, index) => (
          <button
            key={index}
            className={`inline-block py-4 px-12 font-canossaBd text-2xl ${
              activeTab === index
                ? "bg-lightgrey text-secondary"
                : "bg-submenugrey text-bannergrey hover:bg-lightgrey hover:text-secondary"
            }`}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab((prevState) => index);
            }}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className="flex w-full basis-full flex-wrap">
        {tabContent?.map((tab, index) => {
          const imageContent = getImage(
            tab?.imageContent?.image?.localFile?.childImageSharp
              ?.gatsbyImageData
          );
          return (
            <div
              key={index}
              className={`w-full basis-full py-4 px-4 ${
                activeTab === index ? "block" : "hidden"
              }`}
            >
              {tab.commonContent && (
                <div
                  className="page-content w-full basis-full px-4 font-futuraLt text-xl font-semibold text-bannergrey"
                  dangerouslySetInnerHTML={{ __html: tab.commonContent }}
                ></div>
              )}
              {tab.contentType === "twoColumn" ? (
                <div className="flex flex-wrap">
                  <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                    {tab.column1?.map((column, columnIndex) => (
                      <Fragment key={columnIndex}>
                        {column.title && (
                          <h4 className="mb-4 mt-6 font-futuraMd text-xl text-black">
                            {column.title}
                          </h4>
                        )}
                        {column.content && (
                          <div
                            className="page-content font-futuraLt text-xl font-semibold text-bannergrey"
                            dangerouslySetInnerHTML={{ __html: column.content }}
                          ></div>
                        )}
                      </Fragment>
                    ))}
                  </div>
                  <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                    {tab.column2?.map((column, columnIndex) => (
                      <Fragment key={columnIndex}>
                        {column.title && (
                          <h4 className="mb-4 mt-6 font-futuraMd text-xl text-black">
                            {column.title}
                          </h4>
                        )}
                        {column.content && (
                          <div
                            className="page-content font-futuraLt text-xl font-semibold text-bannergrey"
                            dangerouslySetInnerHTML={{ __html: column.content }}
                          ></div>
                        )}
                      </Fragment>
                    ))}
                  </div>
                </div>
              ) : tab.contentType === "imageContent" ? (
                <div className="flex flex-wrap">
                  <div
                    className={`${
                      tab.imageContent.imagePosition === "left" && "order-2"
                    } w-full basis-full px-4 lg:w-1/2 lg:basis-1/2`}
                  >
                    {tab.imageContent.title && (
                      <h4 className="mb-4 font-futuraMd text-xl text-black">
                        {tab.imageContent.title}
                      </h4>
                    )}
                    {tab.imageContent.content && (
                      <div
                        className="page-content font-futuraLt text-xl font-semibold text-bannergrey"
                        dangerouslySetInnerHTML={{
                          __html: tab.imageContent.content,
                        }}
                      ></div>
                    )}
                  </div>
                  {imageContent && (
                    <div
                      className={`${
                        tab.imageContent.imagePosition === "left" && "order-1"
                      } w-full basis-full px-4 lg:w-1/2 lg:basis-1/2`}
                    >
                      <GatsbyImage image={imageContent} alt="" />
                    </div>
                  )}
                </div>
              ) : tab.contentType === "faq" ? (
                <FAQs data={tab.faqs} />
              ) : (
                ""
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
